import {cookies} from './cookies.js'

let clearStorage = function() {
    let lastHost = cookies.getCookie('lastHost');
    if (lastHost == undefined) { // зашли первый раз
        cookies.setCookie('lastHost', location.host);
        localStorage.clear();
    } else if (lastHost !== location.host) { // сабдомен  изменился
        cookies.deleteCookie('lastHost');
        cookies.setCookie('lastHost', location.host);
        localStorage.clear();
    }
}

export {clearStorage}